export const mailingAddressDataSelector = (state) => state.MailingAddressData;
